import iconCss from './Svg/css.svg';
import iconHtml from './Svg/html.svg';
import iconJavascript from './Svg/javascript.svg';
import iconPostgres from './Svg/postgress.svg';
import iconReact from './Svg/react.svg';
import iconRedux from './Svg/redux.svg';
import iconSequelize from './Svg/sequelize.svg';
import iconNode from './Svg/nodeJS.svg';
import iconExpo from './Svg/expo.svg';

 export const objTools = [
    {
        tool:"Html",
        icon: iconHtml || 'icon',
    },
    {
        tool:"Css",
        icon: iconCss || 'icon' ,
    },
    {
        tool:"JavaScript",
        icon:iconJavascript || 'icon',
    },
    {
        tool:"NodeJS",
        icon:iconNode,
    },
    {
        tool:"ReactJS",
        icon:iconReact || 'icon',
    },
    {
        tool:"React Native",
        icon: iconReact ||'icon',
    },
    {
        tool:"Expo",
        icon:iconExpo,
    },
    {
        tool:"Redux",
        icon:iconRedux ||'icon',
    },
    {
        tool:"Postgress",
        icon:iconPostgres || 'icon',
    },
    {
        tool:"Sequelize",
        icon:iconSequelize,
    },
];
